export const TEST_IDS = {
  // Nav
  navHome: "nav-home",
  navDashboard: "nav-dashboard",
  navNew: "nav-new-portfolio",
  navCompare: "nav-compare",
  navLogout: "nav-logout",
  navLogin: "nav-login",
  navRegister: "nav-register",

  // Google
  googleSignIn: "google-signin-button",

  // Landing
  ctaGetStarted: "cta-get-started",
  ctaExplore: "cta-explore",

  // Auth
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",
  registerName: "register-name-input",
  registerEmail: "register-email-input",
  registerPassword: "register-password-input",
  registerSubmit: "register-submit-button",
  switchToRegister: "auth-switch-register",
  switchToLogin: "auth-switch-login",

  // Dashboard
  dashboardEmpty: "dashboard-empty",
  portfolioCard: "portfolio-card",
  portfolioDelete: "portfolio-delete",
  portfolioOpen: "portfolio-open",

  // Builder
  builderName: "builder-name-input",
  builderDescription: "builder-description-input",
  builderInitial: "builder-initial-input",
  builderStart: "builder-start-input",
  builderEnd: "builder-end-input",
  builderDrip: "builder-drip-switch",
  builderAddTicker: "builder-add-ticker-input",
  builderAddTickerButton: "builder-add-ticker-button",
  builderHoldingRow: "builder-holding-row",
  builderRemoveHolding: "builder-remove-holding",
  builderHoldingWeight: "builder-holding-weight",
  builderRunBacktest: "builder-run-backtest",
  builderSave: "builder-save",

  // Results
  metricFinalValue: "metric-final-value",
  metricTotalReturn: "metric-total-return",
  metricCagr: "metric-cagr",
  metricDividends: "metric-dividends",
  metricYoc: "metric-yoc",
  aiExplainButton: "ai-explain-button",
  aiExplainText: "ai-explain-text",
  chartValue: "chart-portfolio-value",
  chartDividends: "chart-cumulative-dividends",
  contributionsTable: "contributions-table",

  // Compare
  compareSelect: "compare-select",
  compareCard: "compare-card",

  // Holdings
  navHoldings: "nav-holdings",
  holdingsAccountTabs: "holdings-account-tabs",
  holdingsAccountAdd: "holdings-account-add",
  holdingsAddPositionButton: "holdings-add-position-button",
  holdingsPasteButton: "holdings-paste-button",
  holdingsPasteTextarea: "holdings-paste-textarea",
  holdingsPasteApply: "holdings-paste-apply",
  holdingsPositionsTable: "holdings-positions-table",
  holdingsPositionRow: "holdings-position-row",
  holdingsRemovePosition: "holdings-remove-position",
  holdingsSaveButton: "holdings-save-button",
  holdingsMetricValue: "holdings-metric-value",
  holdingsMetricMonthlyIncome: "holdings-metric-monthly-income",
  holdingsMetricYoc: "holdings-metric-yoc",
  holdingsMetricGain: "holdings-metric-gain",
  holdingsExDivCalendar: "holdings-ex-div-calendar",
  dashboardHoldingsCard: "dashboard-holdings-card",
};
